<template>
  <transition name="fade">
    <div class="preloader" v-if="isVisible">
      <span class="preloader__item preloader__item--1"/>
      <span class="preloader__item preloader__item--2"/>
      <span class="preloader__item preloader__item--3"/>
      <span class="preloader__item preloader__item--4"/>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  $size: 2.5vw / 2;

  .preloader {
    @include full-size(fixed);
    @include center;
    z-index: z(gate) - 1;

    background-color: #fefefe;
  }

  .preloader__item {
    content: "";
    display: block;

    position: absolute;
    width: $size;
    height: $size;
    left: 50%;
    top: 50%;

    background-color: $accent-color;
    border-radius: 50%;
    z-index: 999;

    animation: {
      duration: 2s;
      iteration-count: infinite;
      fill-mode: both;
    }

    @include media-down(lg) {
      width: $size * 1.5;
      height: $size * 1.5;
    }

    @include media-down(md) {
      width: $size * 2;
      height: $size * 2;
    }
  }

  .preloader__item--1 {
    animation-name: orbit-top-left;
  }

  .preloader__item--2 {
    animation-name: orbit-top-right;
  }

  .preloader__item--3 {
    animation-name: orbit-down-left;
  }

  .preloader__item--4 {
    animation-name: orbit-down-right;
  }

  @keyframes orbit-top-left {
    0% {
      transform: rotate3d(0, 0, 1, 0deg) translate3d(0, 0, 0);
    }
    20% {
      transform: rotate3d(0, 0, 1, 0deg) translate3d(150%, 150%, 0);
    }
    80% {
      transform: rotate3d(0, 0, 1, 360deg) translate3d(150%, 150%, 0);
    }
    100% {
      transform: rotate3d(0, 0, 1, 360deg) translate3d(0, 0, 0);
    }
  }

  @keyframes orbit-top-right {
    0% {
      transform: rotate3d(0, 0, 1, 0deg) translate3d(0, 0, 0);
    }
    20% {
      transform: rotate3d(0, 0, 1, 0deg) translate3d(150%, -150%, 0);
    }
    80% {
      transform: rotate3d(0, 0, 1, 360deg) translate3d(150%, -150%, 0);
    }
    100% {
      transform: rotate3d(0, 0, 1, 360deg) translate3d(0, 0, 0);
    }
  }

  @keyframes orbit-down-left {
    0% {
      transform: rotate3d(0, 0, 1, 0deg) translate3d(0, 0, 0);
    }
    20% {
      transform: rotate3d(0, 0, 1, 0deg) translate3d(-150%, -150%, 0);
    }
    80% {
      transform: rotate3d(0, 0, 1, 360deg) translate3d(-150%, -150%, 0);
    }
    100% {
      transform: rotate3d(0, 0, 1, 360deg) translate3d(0, 0, 0);
    }
  }

  @keyframes orbit-down-right {
    0% {
      transform: rotate3d(0, 0, 1, 0deg) translate3d(0, 0, 0);
    }
    20% {
      transform: rotate3d(0, 0, 1, 0deg) translate3d(-150%, 150%, 0);
    }
    80% {
      transform: rotate3d(0, 0, 1, 360deg) translate3d(-150%, 150%, 0);
    }
    100% {
      transform: rotate3d(0, 0, 1, 360deg) translate3d(0, 0, 0);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Preloader.vue